var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('v-tabs',{attrs:{"centered":"","color":_vm.accentColor,"background-color":"transparent"},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab',[_vm._v(_vm._s(_vm.$t('vueBlock_create.create')))]),_c('v-tab',[_vm._v(_vm._s(_vm.$t('vueBlock_create.duplicate')))])],1),_c('v-tabs-items',{staticStyle:{"background-color":"transparent"},attrs:{"dark":_vm.isDark},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab-item',[_c('v-card-text',{staticStyle:{"padding":"0px"}},[_c('MutationForm',{attrs:{"no-reset":"","mutation":"createVueBlock","constants":{ environmentId: _vm.environmentId },"submitButtonText":_vm.$t('vueBlock_create.create'),"submitButtonIcon":"add","submit-button-color":_vm.accentColor,"schema":{
            environmentId: {
              __graphQLType: 'ID'
            },
            name: {
              label: _vm.$t('vueBlock_create.schema.name.label'),
              type: 'string',
              description: _vm.$t('vueBlock_create.schema.name.description'),
              fieldOptions: {
                color: _vm.accentColor
              },
              newDesign: true,
              isDark: this.isDark
            },
            title: {
              label: _vm.$t('vueBlock_create.schema.title.label'),
              type: 'string',
              optional: true,
              description: _vm.$t('vueBlock_create.schema.title.description'),
              fieldOptions: {
                color: _vm.accentColor
              },
              newDesign: true,
              isDark: this.isDark
            }
          }},on:{"success":function($event){return _vm.$emit('create', $event)},"error":function($event){return _vm.$emit('error', $event)}}},[_c('v-btn',{attrs:{"slot":"left-buttons","dark":"","color":"#59a4f4"},on:{"click":function($event){return _vm.$emit('dismiss')}},slot:"left-buttons"},[_vm._v(_vm._s(_vm.$t('vueBlock_create.cancelBtn')))])],1)],1)],1),_c('v-tab-item',[_c('v-card-text',{class:{ 'white--text': _vm.isDark }},[_c('div',{staticClass:"overline"},[_vm._v(_vm._s(_vm.$t('vueBlock_create.duplicateInfo')))]),_c('div',{staticClass:"caption"},[_vm._v(" "+_vm._s(_vm.$t('vueBlock_create.dupliDescp'))+" ")]),_c('div',{staticClass:"overline"},[_vm._v(_vm._s(_vm.$t('vueBlock_create.wontDupli')))]),_c('div',{staticClass:"caption"},[_vm._v(_vm._s(_vm.$t('vueBlock_create.wontDupli1')))]),_c('div',{staticClass:"caption"},[_vm._v(" "+_vm._s(_vm.$t('vueBlock_create.wontDupli2'))+" ")]),_c('MutationForm',{attrs:{"no-reset":"","mutation":"duplicateVueBlock","environmentVariables":{ environmentId: _vm.environmentId },"submitButtonText":_vm.$t('vueBlock_create.duplicate'),"submitButtonIcon":"content_copy","submit-button-color":_vm.accentColor,"schema":{
            vueBlockId: {
              __graphQLType: 'ID',
              label: _vm.$t('vueBlock_create.schema.vueBlockId.label'),
              fieldType: 'componentSelect',
              fieldOptions: {
                componentTypeName: 'vueBlocks'
              },
              newDesign: true
            },
            newName: {
              label: _vm.$t('vueBlock_create.schema.newName.label'),
              type: 'string',
              description: _vm.$t('vueBlock_create.schema.newName.description'),
              fieldOptions: {
                color: _vm.accentColor
              },
              newDesign: true,
              isDark: this.isDark
            }
          }},on:{"success":function($event){return _vm.$emit('create', $event)},"error":function($event){return _vm.$emit('error', $event)}}},[_c('v-btn',{attrs:{"slot":"left-buttons","dark":"","color":"#59a4f4"},on:{"click":function($event){return _vm.$emit('dismiss')}},slot:"left-buttons"},[_vm._v(_vm._s(_vm.$t('vueBlock_create.cancelBtn')))])],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }